
class NavHeightHelper {

    GetHeight = () => {
        let w = window.innerWidth;
        if (w <= 768) {
            return 61;
        } else if (w <= 1230) {
            return 84;
        } else {
            return 71;
        }
    }
}

export default NavHeightHelper;